// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__Qvyeh","consentsList":"PatientConsents_consentsList__2fl3j","consentsListEmpty":"PatientConsents_consentsListEmpty__2B-FU"};